import Vue from 'vue'
import configuration from '@/config'
import store from '@/store'
import { getUserToken, setUserToken } from '@/utils/localStorage'

async function handleIndexPage(to, from, next) {
  if (Vue.prototype.$liff.isLoggedIn()) {
    if (to.query.redirectPath) {
      next({
        path: to.query.redirectPath,
        query: { ...to.query, redirectPath: undefined }
      })
    } else {
      next({ path: '/home' })
    }
  } else {
    next()
  }
}

async function handleDefaultPage(to, from, next) {
  const localUserToken = getUserToken()

  if (!Vue.prototype.$liff.isLoggedIn()) {
    const path = to.name === 'Index' ? '/home' : to.path
    let redirectUri = `${window.origin}?redirectPath=${path}`
    if (to.query.redirectLineOaId) {
      redirectUri += `&redirectLineOaId=${to.query.redirectLineOaId}`
    }

    next({
      path: '/',
      query: { redirectUri }
    })
    return
  }

  if ((!Vue.prototype.$liff.isInClient() && !localUserToken) || (Vue.prototype.$liff.isInClient() && !store.getters['Auth/isLogin'])) {
    store.dispatch('wait/start', 'app loading', { root: true })
    const profile = await Vue.prototype.$liff.getProfile()
    const email = await Vue.prototype.$liff.getDecodedIDToken().email
    const params = {
      ...profile,
      uid: profile.userId,
      email
    }

    const { userToken } = await store.dispatch('Auth/login', params)
    setUserToken(userToken)
    store.dispatch('wait/end', 'app loading', { root: true })
  }
  next()
}

export default async (to, from, next) => {
  await Vue.prototype.$liff.init({ liffId: configuration.LINE_LIFF_ID })

  if (to.name === 'Index') {
    await handleIndexPage(to, from, next)
  } else {
    await handleDefaultPage(to, from, next)
  }
}
